<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="video-muted"
      :class="{ 'is-full-screen': isFullScreen }"
    >
      <icon :type="this.isMuted ? 'iconicon_mute' : 'iconicon_volume'" @click.native="handleOpenVolume"></icon>
      <div class="video-muted-notice">当前浏览器仅支持静音连播</div>
      <div class="video-muted-control">
        <span class="video-muted-control-button" @click="handleClose">忽略</span>
        <span class="video-muted-control-button" @click="handleOpenVolume">开启声音</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    player: {
      type: Object,
      default: () => ({}),
    },

    isFullScreen: Boolean
  },

  data() {
    return {
      visible: false,
      isMuted: true
    };
  },

  watch: {
    show(val) {
      if (val) {
        this.open();
      } else {
        this.close();
      }
    },
  },

  methods: {
    open() {
      this.visible = true;
      this.$emit('update:show', this.visible);
    },

    close() {
      this.visible = false;
      this.$emit('update:show', this.visible);
    },

    handleClose() {
      this.close();
    },

    handleOpenVolume() {
      if (this.player && this.player.muted) {
        this.player.muted(false);
        this.isMuted = false;
      }
      this.$nextTick(() => {
        this.close();
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.video-muted {
  position: absolute;
  bottom: 44px;
  right: 24px;

  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 32px;
  padding: 5px 14px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  font-size: 12px;
  color: #FFFFFF;

  font-family: '微软雅黑';

  .icon {
    font-size: 16px;
    cursor: pointer;
  }

  &.is-full-screen {
    bottom: 46px;
  }

  &-notice {
    margin: 0px 32px 0px 8px;
  }

  &-control {
    display: flex;

    &-button {
      user-select: none;
      color: rgba(255, 255, 255, 0.6);
      cursor: pointer;

      &:last-child {
        color: rgba(255, 170, 0, 0.85);
        margin-left: 14px;
      }
    }
  }
}

.fade {
  &-enter-active {
    transition: all 1s;
  }

  &-leave-active {
    transition: all 1s;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>
